import {EventEmitter, Injectable} from '@angular/core';
import {Event} from '../../../../model/events/Event';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class EventFrontendDataService
{
  dataLoaded: boolean;
  showPerformances: boolean;
  showStatistics: boolean;
  showTable: boolean;
  showPlacement: boolean;
  showStatisticsStatistics: boolean;
  showStatisticsStatisticsTeams: boolean;
  showStatisticsPlayerResult: boolean;
  showStatisticsPlayerRanking: boolean;

  dataIntern: Event;
  onEventChanged = new EventEmitter<any>();
  get eventData(): Event
  {
    return this.dataIntern;
  }
  set eventData(value: Event)
  {
    this.dataIntern = value;
    this.onEventChanged?.emit(this.dataIntern);
  }

  mainEventsIntern: Event[];
  onMainEventsChanged = new EventEmitter<Event[]>();
  set mainEvents(item: Event[])
  {
    this.mainEventsIntern = item;
    this.onMainEventsChanged?.emit(item);
  }
  get mainEvents(): Event[]
  {
    return this.mainEventsIntern;
  }
}
